import { combine, createEvent, createStore } from 'effector';
import { $orgInfo } from '@nx-frontend/shared/store/org-info';
import { BillingInfo, BillingInfoPlan } from '@nx-frontend/shared/types';

export const initialBillingInfoState: BillingInfo = {
  orgId: '',
  subscriptionId: '',
  plan: BillingInfoPlan.NOPE,
  createdAt: 0,
  updatedAt: 0,
  members: 0,
  active: false,
  inheritedFromOrgs: [],
  membersIncludingOwner: true,
  trialEndsAt: 0,
};

export const setBillingInfoEvent = createEvent<BillingInfo>();

export const $billingInfo = createStore(initialBillingInfoState).on(setBillingInfoEvent, (state, billingInfo) => {
  return { ...state, ...billingInfo };
});

export const $isFreePlan = combine($orgInfo, (orgInfo) => {
  return ['standard'].includes(orgInfo.subscriptionType);
});
